import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { ApiRoutes } from 'app/routes/app.routes';
import { HttpService } from '../http/http.service';

@Injectable({
  providedIn: 'root',
})
export class ClassroomService {
  private baseUrl: string = ApiRoutes.api.baseUrl;
  private routes = ApiRoutes.api;
  constructor(
    private http: HttpClient,
    private readonly httpService: HttpService
  ) { }

  addClassroom(payload: any) {
    return this.httpService.makeRequest({
      path: this.routes.classroom.add,
      method: 'post',
      options: { body: payload },
      loader: { type: 'spinner' },
      isAuthRoutes: true
    });
  }

  allClassrooms(pagination?: { page?: number; limit?: number }) {
    const params: any = {};

    if (pagination) {
      if (pagination.page) params.page = pagination.page;
      if (pagination.limit) params.limit = pagination.limit;
    }

    return this.httpService.makeRequest({
      path: this.routes.classroom.retrieve,
      method: 'get',
      options: { params },
      loader: { type: 'spinner' },
      isAuthRoutes: true
    });
  }

  getClassroom(id: number) {
    return this.httpService.makeRequest({
      path: this.routes.classroom.retrieveSingle,
      method: 'get',
      options: { id },
      loader: { type: 'spinner' },
      isAuthRoutes: true
    });
  }

  getClassMasterSheet(id: number) {
    return this.httpService.makeRequest({
      path: this.routes.result.downloadClassMasterSheet,
      method: 'get',
      options: { id },
      loader: { type: 'spinner' },
      isAuthRoutes: true
    });
  }

  downloadClassMasterSheet(id: number) {
    return this.httpService.makeRequest({
      path: this.routes.result.downloadClassMasterSheet,
      method: 'get',
      options: { id, responseType: 'blob' },
      loader: { type: 'spinner' },
      isAuthRoutes: true
    });
  }

  deleteClassroom(id: string) {
    return this.httpService.makeRequest({
      path: this.routes.classroom.delete,
      method: 'delete',
      options: { id },
      loader: { type: 'spinner' },
      isAuthRoutes: true
    });
  }

  updateClassroom(id: number, payload: any) {
    return this.httpService.makeRequest({
      path: this.routes.classroom.edit,
      method: 'put',
      options: { id, body: payload },
      loader: { type: 'spinner' },
      isAuthRoutes: true
    });
  }

  bulkDelete(payload: { ids: number[] }) {
    return this.httpService.makeRequest({
      path: this.routes.classroom.bulkDelete,
      method: 'delete',
      options: { body: payload },
      loader: { type: 'spinner' },
      isAuthRoutes: true
    });
  }

  mergeClassrooms(sourceId: number, targetId: number) {
    return this.httpService.makeRequest({
      path: this.routes.classroom.merge,
      method: 'post',
      options: {
        body: { source_id: sourceId, target_id: targetId }
      },
      loader: { type: 'spinner' },
      isAuthRoutes: true
    });
  }

  getClassroomsBySeries(seriesId: number) {
    return this.httpService.makeRequest({
      path: this.routes.classroom.retrieve,
      method: 'get',
      options: { params: { series: seriesId } },
      loader: { type: 'spinner' },
      isAuthRoutes: true
    });
  }

  getClassroomsByDepartment(departmentId: number) {
    return this.httpService.makeRequest({
      path: this.routes.classroom.retrieve,
      method: 'get',
      options: { params: { department: departmentId } },
      loader: { type: 'spinner' },
      isAuthRoutes: true
    });
  }

  assignClassMaster(classroomId: number, payload: { teacherIds: number[] }) {
    return this.httpService.makeRequest({
      path: this.routes.classroom.assignClassMaster,
      method: 'post',
      options: { id: classroomId, body: payload },
      loader: { type: 'spinner' },
      isAuthRoutes: true
    });
  }
}
